"use strict";

/*
  Status:
  0 = unknown
  1 = noFlow
  2 = flow
*/

/*check if delta is below 0.25 dl*/
function isNear(val1, val2) {
  return Math.abs(val1 - val2) < 0.25;
}

module.exports = function(config, result) {

  // first check that we have desilitre pointer available
  var pointersMatches = 0;
  if (config.decimals.useCoords) {
    if (config.decimals.positions[0].precision == 0.0001 // first check that we have desilitre pointer available
     && config.previousPointers // previous pointers needs to exist
     && config.previousPointers.meters && config.previousPointers.meters.length //previous round should have meters available
     && result.meters && result.meters.length //current round should have meters available
     && config.previousPointers.meters[0].positionIndex == 0 //previous round should have desilitre pointer
     && result.meters[0].positionIndex == 0 //current round should have desilitre pointer
     && result.meters[0].value > -1 // new and previous pointers should have meaningfull value
     && config.previousPointers.meters[0].value > -1) {
      // first check that desilitre matches
      var res = isNear(result.meters[0].value, config.previousPointers.meters[0].value);
      if (res) {
        // check also other pointers
        for (var i = 1; i < result.meters.length; i++) {
          for (var j = 1; j < config.previousPointers.meters.length; j++) {
            if (result.meters[i].positionIndex == config.previousPointers.meters[j].positionIndex) {
              res = isNear(result.meters[i].value, config.previousPointers.meters[j].value);
              if (!res) {
                return {status:2};
              } // no need to handle else, success is hadled few rows below
            }
          }
        }
        return {status:1}; // if desilitre pointers match and possible others also -> return noflow
      } else { // desilitre pointer has moved -> some sort of flow definately
        return {status:2};
      }
    } else {
      return {status:0}
    }
  } else {
    return {status:0}
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/flowone-algorithms/decimalpointers/check-flow.js
// module id = 835
// module chunks = 0